import { useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
    const translate = useTranslate();
    const location = useLocation();

    useEffect(() => {
        // Use setTimeout to ensure we override React Admin's title after it sets it
        const timer = setTimeout(() => {
            const path = location.pathname;
            // Produktuebergreifende Verwaltung — admin:panel-Zwischenmarke.
            const suffix = 'admin:panel';
            let title = suffix;

            // Parse the current route to determine the page title
            if (path === '/' || path === '') {
                title = `Dashboard - ${suffix}`;
            } else if (path === '/login') {
                title = `Login - ${suffix}`;
            } else if (path.startsWith('/companies')) {
                const resourceTitle = translate('resources.companies.name', { smart_count: 2 });
                if (path.includes('/create')) {
                    title = `${translate('ra.page.create', { name: resourceTitle })} - ${suffix}`;
                } else if (path.match(/\/companies\/\d+$/)) {
                    title = `${resourceTitle} - ${suffix}`;
                } else {
                    title = `${resourceTitle} - ${suffix}`;
                }
            } else if (path.startsWith('/users')) {
                const resourceTitle = translate('resources.users.name', { smart_count: 2 });
                if (path.includes('/create')) {
                    title = `${translate('ra.page.create', { name: resourceTitle })} - ${suffix}`;
                } else if (path.match(/\/users\/\d+$/)) {
                    title = `${resourceTitle} - ${suffix}`;
                } else {
                    title = `${resourceTitle} - ${suffix}`;
                }
            } else if (path.startsWith('/roles')) {
                const resourceTitle = translate('resources.roles.name', { smart_count: 2 });
                title = `${resourceTitle} - ${suffix}`;
            } else if (path.startsWith('/permissions')) {
                const resourceTitle = translate('resources.permissions.name', { smart_count: 2 });
                title = `${resourceTitle} - ${suffix}`;
            } else if (path.startsWith('/products')) {
                const resourceTitle = translate('resources.products.name', { smart_count: 2 });
                title = `${resourceTitle} - ${suffix}`;
            } else if (path.startsWith('/licenses')) {
                const resourceTitle = translate('resources.licenses.name', { smart_count: 2 });
                title = `${resourceTitle} - ${suffix}`;
            }

            document.title = title;
        }, 0);

        return () => clearTimeout(timer);
    }, [location.pathname, translate]);

    return null;
};

export default PageTitle;
